module.exports = __webpack_public_path__ + "static/media/sello.dbbdb60c.png";